/* src/app/modules/portal/components/system-overview/system-overview.component.scss */
:host {
  flex: 1 0;
  display: flex;
  flex-direction: column;
}
api-call-gate {
  margin: auto;
}
.layout {
  display: grid;
  gap: var(--gap);
  grid-template-columns: [main] 8fr [widgets] 4fr;
  grid-auto-rows: auto;
  overflow-x: hidden;
  padding-bottom: 0.5rem;
}
.main {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  grid-column-start: main;
  grid-area: main;
}
.widgets {
  display: flex;
  flex-direction: row;
  gap: var(--gap);
  grid-column-start: widgets;
}
.widgets .datasourcecards {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
}
.apps {
  grid-area: helpfulLinks;
  margin-bottom: auto;
}
app-doc-box-panel {
  display: none !important;
}
[screen-desktop-large] :host-context .layout {
  display: grid;
  grid-template-areas: "main    widgets" "tickets widgets";
}
[screen-desktop-large] :host-context app-companions-panel {
  margin-bottom: auto;
}
[screen-desktop-large] :host-context app-planned-activities-panel {
  margin-bottom: auto;
  text-wrap: nowrap;
  margin-right: 0.5rem;
}
[screen-desktop-large] :host-context .widgets {
  grid-area: widgets;
  display: grid;
  grid-template: repeat(2, 0fr)/auto auto;
}
[screen-desktop-large] :host-context .apps-records {
  display: grid;
  grid-template-columns: subgrid;
  row-gap: 1rem;
}
[screen-desktop] :host-context .layout {
  display: grid;
  grid-template-columns: 9fr 3fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: "main    widgets" "tickets widgets";
  grid-auto-columns: auto;
}
[screen-desktop] :host-context .widgets {
  grid-area: widgets;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: min-content min-content min-content max-content;
  grid-template-areas: "apps" "planned" "helpfulLinks" "spacer";
}
[screen-desktop] :host-context .widget--no-apps {
  grid-template-areas: "planned" "helpfulLinks" "spacer";
}
[screen-desktop] :host-context app-companions-panel {
  grid-area: apps;
}
[screen-desktop] :host-context app-doc-box-panel {
  grid-area: docbox;
}
[screen-desktop] :host-context app-spare-parts-panel {
  grid-area: tickets;
  margin-bottom: auto;
}
[screen-desktop] :host-context app-planned-activities-panel {
  grid-area: planned;
}
[screen-desktop] :host-context [spacer] {
  grid-area: spacer;
  height: auto;
}
[screen-tablet] :host-context .layout {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min-content min-content auto;
  grid-template-areas: "main    main" "tickets rightColumn" "planned rightColumn";
}
[screen-tablet] :host-context .right-column {
  grid-area: rightColumn;
  gap: var(--gap);
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: min-content min-content min-content max-content;
  grid-template-areas: "apps" "planned" "helpfulLinks" "spacer";
}
[screen-tablet] :host-context .right-column--no-apps {
  grid-template-areas: "planned" "helpfulLinks" "spacer";
}
[screen-tablet] :host-context app-companions-panel {
  grid-area: apps;
}
[screen-tablet] :host-context app-spare-parts-panel {
  grid-area: tickets;
  margin-bottom: none;
}
[screen-tablet] :host-context app-planned-activities-panel {
  grid-area: planned;
  margin-bottom: auto;
}
[screen-phone] :host-context .layout {
  display: flex;
  flex-direction: column;
}
.modules-pane {
  margin-right: 0px;
  background-color: var(--base-2);
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 400px;
}
.module-item {
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  width: 100%;
}
.module-item:hover {
  background-color: var(--base-2);
}
.module-item-active {
  background-color: var(--base-1);
}
.module-text-active {
  font-weight: bolder;
}
.psm-spinner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
}
#loading-indicator-system-overview {
  margin: auto;
  margin-top: 35vh;
  position: absolute;
  width: 100vw;
  left: 0;
}
.right-side-pane {
  width: 270px;
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
}
.mi-layout {
  margin: 0.5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
}
.mi-panel {
  flex: 1 0;
  width: 270px;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  margin-right: 1rem;
}
#psmOverviewIframe {
  border: 0px;
  width: 100%;
  height: 95%;
}
/*# sourceMappingURL=system-overview.component.css.map */
